// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as StimulusTabContext$LiteracyplanetTupperware from "../v2/StimulusTabContext.res.mjs";
import * as StimulusToggleContext$LiteracyplanetTupperware from "../v2/StimulusToggleContext.res.mjs";

function PilotStimulusContainer(props) {
  return React.createElement(StimulusToggleContext$LiteracyplanetTupperware.make, {
              show: true,
              children: React.createElement(StimulusTabContext$LiteracyplanetTupperware.make, {
                    tabs: props.tabs,
                    children: props.children
                  })
            });
}

var make = PilotStimulusContainer;

var $$default = PilotStimulusContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
